<template>
  <d-form-row>
    <d-col md="12" class="form-group">
      <d-tabs ref="tabs">
        <d-tab
          v-for="(tab, index) in tabs"
          :title="tab.name"
          class="p-3"
          :key="index"
        >
          <component :is="tab.component" :quotation.sync="quotation" />
        </d-tab>
      </d-tabs>
    </d-col>
  </d-form-row>
</template>

<script>
import QuotationTab from './QuotationTab.vue';

export default {
  name: 'Variable-quotation',
  props: {
    model: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      tabs: {
        quotation: {
          name: 'Orçamentos',
          component: 'QuotationTab',
        },
      },
    };
  },
  components: {
    QuotationTab,
  },
  computed: {
    quotation: {
      get() {
        return this.model.quotation;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
